import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { getFormValues, isPristine } from "redux-form";
import { Grid, Header } from "semantic-ui-react";
import { getNativeTemplate } from "../../firebase";
import "./default.css";
import Form from "./form";
import Info from "./info";
import Loading from "../../app/loading";
import { EditButton, CancelButton, DuplicateButton } from "../utils/buttons";
import Banner from "./banner";

const Stage = ({ defaultForm, location, id, template, retailer, pristine }) => {
  const params = useParams();

  const user = useSelector((state) => state.user);
  const banner = useSelector((state) => state.banner);

  const [bannerData, setBannerData] = useState({});
  const [templateName, setTemplateName] = useState();
  const [nativeTemplate, setNativeTemplate] = useState();
  const [nativeStyle, setNativeStyle] = useState();
  const [selectors, setSelectors] = useState();
  const [cleanHmtlTags, setCleanHtmlTags] = useState(true);
  const [inEdit, setInEdit] = useState();
  const [formOrInfo, setFormOrInfo] = useState(<Info />);
  //const [path, setPath] = useState();

  useEffect(() => {
    const data = defaultForm || banner;
    setBannerData(data);
    return () => {
      setBannerData({});
    };
  }, [defaultForm, banner, id]);

  useEffect(() => {
    if (templateName) {
      getNativeTemplate(retailer, templateName).then((data) => {
        if (data) {
          let code = data.htmlSnippet.replace(/[[\]]+/g, "");
          let styles = "";

          if (code.indexOf("<style>") !== -1) {
            styles = code.match(/<style>([\s\S]*?)<\/style>/g);
            code = code.replace(styles[0], "");
            styles = styles[0].replace(/<\/?style>/g, "");
          }
          if (data.cssSnippet) {
            styles = data.cssSnippet.replace(/[[\]]+/g, "");
          }
          setNativeTemplate(code);
          setNativeStyle(styles);
          setSelectors(data.selectors);
          if (data.cleanTags !== undefined) setCleanHtmlTags(data.cleanTags);
        }
      });
    }
  }, [templateName, retailer]);

  useEffect(() => {
    if (template) {
      setTemplateName(template);
    }
  }, [template]);

  useEffect(() => {
    if (!_.isEmpty(bannerData)) {
      setTemplateName(bannerData.bannerType);
    }
  }, [bannerData]);

  useEffect(() => {
    const loc = location.pathname.split("/");
    const status = loc[4] ? true : false;
    setInEdit(status);
  }, [location.pathname]);

  useEffect(() => {
    if ((user && params["*"] === "edit") || (user && params["template"])) {
      setFormOrInfo(<Form retailer={retailer} />);
    } else {
      setFormOrInfo(<Info />);
    }
  }, [params, user, retailer]);

  if (!nativeStyle || !bannerData || !nativeTemplate) return <Loading />;

  return (
    <>
      <Grid padded>
        <Grid.Row className="bm-title-row">
          <Grid.Column computer={10} tablet={8} mobile={16}>
            <Header as="h3" content={bannerData.bannerTitle} />
          </Grid.Column>
          {user && (
            <Grid.Column computer={6} tablet={8} mobile={16}>
              {bannerData.key && !inEdit && (
                <DuplicateButton
                  data={bannerData}
                  location={location}
                  inUse={bannerData.currentUser}
                  size="mini"
                />
              )}
              {!inEdit && (
                <EditButton
                  id={id}
                  inUse={bannerData.currentUser}
                  size="mini"
                />
              )}
              <CancelButton
                id={id}
                location={location}
                retailer={retailer}
                pristine={pristine}
                size="mini"
              />
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
      <Banner
        banner={bannerData}
        template={nativeTemplate}
        style={nativeStyle}
        selectors={selectors}
        cleanTags={cleanHmtlTags}
        user={user}
      />
      {formOrInfo}
    </>
  );
};

export default connect((state) => ({
  defaultForm: getFormValues("defaultForm")(state),
  pristine: isPristine("defaultForm")(state),
}))(Stage);
